module.exports = __webpack_public_path__ + "static/media/Lista-SOPsImportant.b7eb1c76.png";